<template>
  <section id="voices" class="rk-testimonials">
    <div class="rk-container">
      <div class="rk-section__head" v-reveal>
        <span class="rk-eyebrow rk-eyebrow--dark"><i class="bi bi-quote"></i> Trusted by landlords</span>
        <h2>People managing real properties, not demo data</h2>
        <div class="rk-stars" aria-label="Rated 4.3 out of 5">
          <i class="bi bi-star-fill" v-for="n in 4" :key="n"></i>
          <i class="bi bi-star-half"></i>
          <span>4.3 average from landlords using the platform</span>
        </div>
      </div>

      <div class="rk-quotes">
        <article class="rk-quote rk-quote--offset" v-reveal="{ variant: 'left' }">
          <i class="bi bi-quote rk-quote__mark"></i>
          <p>
            "I used to chase rent through a WhatsApp group with forty tenants in it.
            Now the reminders go out on their own and I just watch the collection
            rate climb."
          </p>
          <div class="rk-quote__author">
            <img
              src="https://images.unsplash.com/photo-1611432579699-484f7990b127?fm=jpg&q=70&w=200&auto=format&fit=crop"
              alt="Portrait of a landlord"
            >
            <div>
              <strong>Faith W.</strong>
              <span>Landlord, 3 properties · Nairobi</span>
            </div>
          </div>
        </article>

        <article class="rk-quote" v-reveal="{ variant: 'right', delay: 100 }">
          <i class="bi bi-quote rk-quote__mark"></i>
          <p>
            "Switching agents used to mean starting from a blank spreadsheet.
            Now every unit, every lease, every payment stays with the
            property, not the person managing it."
          </p>
          <div class="rk-quote__author">
            <img
              src="https://images.unsplash.com/photo-1624224416603-c908080780b1?fm=jpg&q=70&w=200&auto=format&fit=crop"
              alt="Portrait of a property agent"
            >
            <div>
              <strong>David O.</strong>
              <span>Property agent · Mombasa Road</span>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style scoped>
.rk-container { max-width: 1200px; margin: 0 auto; padding: 0 1.5rem; }
.rk-testimonials { padding: 6.5rem 0; background: var(--paper-dim); }

.rk-section__head { max-width: 620px; margin: 0 auto 3.5rem; text-align: center; }
.rk-section__head h2 {
  font-family: var(--font-display); font-size: 2.5rem; font-weight: 400;
  color: var(--ink); margin: 1rem 0 1.25rem; line-height: 1.2;
}
.rk-stars {
  display: flex; align-items: center; justify-content: center; gap: 0.35rem;
  font-family: var(--font-mono); font-size: 0.8rem; color: var(--slate-soft);
}
.rk-stars i { color: var(--brass); font-size: 0.95rem; }
.rk-stars span { margin-left: 0.5rem; }
.rk-eyebrow {
  display: inline-flex; align-items: center; gap: 0.5rem;
  font-family: var(--font-mono); font-size: 0.75rem; font-weight: 500;
  padding: 0.4rem 0.85rem; border-radius: 100px;
}
.rk-eyebrow--dark { color: var(--brass); background: var(--brass-light); }

.rk-quotes { display: grid; grid-template-columns: 1fr 1fr; gap: 2rem; }

.rk-quote {
  background: var(--neu-surface);
  box-shadow: var(--neu-raised);
  border-radius: var(--radius-lg); padding: 2.5rem;
  position: relative;
}
.rk-quote--offset { transform: translateY(-1.5rem); }

.rk-quote__mark { position: absolute; top: 1.5rem; right: 1.75rem; font-size: 2rem; color: var(--brass-light); }

.rk-quote p {
  font-family: var(--font-display); font-style: italic; font-size: 1.3rem;
  line-height: 1.5; color: var(--ink); margin: 0 0 2rem; padding-right: 1.5rem;
}

.rk-quote__author { display: flex; align-items: center; gap: 0.85rem; }
.rk-quote__author img { width: 46px; height: 46px; border-radius: 50%; object-fit: cover; border: 2px solid var(--brass-light); }
.rk-quote__author strong { display: block; font-family: var(--font-body); font-size: 0.95rem; color: var(--ink); }
.rk-quote__author span { font-family: var(--font-body); font-size: 0.82rem; color: var(--slate-soft); }

@media (max-width: 768px) {
  .rk-testimonials { padding: 4.5rem 0; }
  .rk-section__head h2 { font-size: 2rem; }
  .rk-quotes { grid-template-columns: 1fr; gap: 1.5rem; }
  .rk-quote--offset { transform: none; }
}
</style>